import { CommonModule, NgClass } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { QuotesStoreService } from '../../../store/quotes-store.service';
import { RecommendedBadgeComponent } from '@webapp/core/ui/components/recommended-badge/recommended-badge.component';
import {CoveragePriceComponent} from '@webapp/core/ui/components/coverage-price/coverage-price.component'
import { ICoverage } from '@webapp/payments';

@Component({
  selector: 'app-quote-coverage-card',
  standalone: true,
  imports: [CommonModule, RecommendedBadgeComponent, NgClass, CoveragePriceComponent],
  templateUrl: './quote-coverage-card.component.html',
  styleUrl: './quote-coverage-card.component.scss',
})
export class QuoteCoverageCardComponent{
  quotesStore = inject(QuotesStoreService);
  quote = this.quotesStore.get()();
  viewDetail = false;
  coverage = input.required<ICoverage>();
  quoteStatus = input.required<string>();
  selectedCoverage = this.quotesStore.select('selectedCoverage');

  
  isFinished() {
    return this.quoteStatus() === 'FINISHED';
  }

  isSelected() {
    if (this.isOptional()) {
      return this.quotesStore
        .select('selectedOptionalCoverages')()
        .includes(this.coverage());
    }
    return this.selectedCoverage() === this.coverage();
  }

  isOptional() {
    return this.quotesStore.get()()?.additionalCoverage === this.coverage();
  }

  getDetailEntries() {
    return this.coverage().items || [];
  }

  toggleViewDetail() {
    this.viewDetail = !this.viewDetail;
  }


  selectCoverage() {
    if (this.isOptional()) {
      this.quotesStore.toggleOptionalCoverage(this.coverage());
      return;
    }

    if (!this.isSelected()) {
      this.quotesStore.set('selectedCoverage', this.coverage());
    }
  }
}
